<div class="page-wrapper pt-4">
    <div class="page-content pt-0 pe-0 ps-0">
        <div class="container-fluid">
            <div class="default_class">
                <div class="content-wrapper p-0">

                    <div class="container-fluid">

                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card rounded shadow-lg">
                                    <div class="card-header  headerbg" style="border-bottom:3px solid #d8eff8;">
                                        <h5 class="mb-0">My Jobs</h5>
                                    </div>
                                    <div class="card-body">

                                        <table id="patreggraph" datatable [dtOptions]="dtOptions"
                                            [dtTrigger]="dtTrigger"
                                            class="table table-striped table-bordered mt-2 pt-2 table-sm small display"
                                            style="width:100%">
                                            <thead class="top" style="background-color: #2e7a91; color:#ffffff;">
                                                <tr>
                                                    <th> Job Name</th>
                                                    <th> Name </th>
                                                    <th> Company </th>
                                                    <th> Application Date </th>
                                                    <th>Mobile No.</th>
                                                    <th> Email </th>
                                                    <th> Skills </th>
                                                    <th>Experience</th>
                                                    <th>Status</th>
                                                    <th></th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let item of listGrid">
                                                    <td>{{item.job_name}}</td>
                                                    <td>{{item.firstname}} {{item.lastname}}</td>
                                                    <td>{{item.company_name}}</td>
                                                    <td>{{item.application_date | date:'dd-MM-yyyy'}}</td>
                                                    <td>{{item.phone_number}}</td>
                                                    <td>{{item.student_email}}</td>
                                                    <td>{{item.skills}}</td>
                                                    <td>{{item.experience_level}}</td>
                                                    <td>{{item.job_application_status_name == null ? 'Pending' :
                                                        item.job_application_status_name}}</td>
                                                    <td>
                                                        <button class="btn btn-primary btn-sm" (click)="ApplyJob(item)">
                                                            View Details
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<input type="button" class="d-none" id="btnShowModel" data-bs-target="#InstallmentDetails" data-bs-toggle="modal">
<app-paid-installments *ngIf="showInstallmentModel" [InstallmentList]="InstallmentList"
    (modelCloseEvent)="showInstallmentModel=false;">
</app-paid-installments>